import { render, staticRenderFns } from "./CollectInfo.vue?vue&type=template&id=02eb3758&scoped=true&"
import script from "./CollectInfo.vue?vue&type=script&lang=ts&"
export * from "./CollectInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eb3758",
  null
  
)

export default component.exports